import { useMutation, useQueryClient } from '@tanstack/react-query';
import { mutationNotif } from '#/utils/mutationNotif';
import { deleteScheduledEnrollments, scheduleEnrollments } from './enrollments';
import { ETC_TICKET_QUERY_NAMESPACE } from './ticketsHooks';

export function useScheduleEnrollment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      enrollmentId,
      scheduledDate,
    }: {
      enrollmentId: string;
      scheduledDate: string;
      ticketId: string;
    }) => scheduleEnrollments(enrollmentId, { scheduledDate }),
    onMutate: ({ enrollmentId }) => {
      mutationNotif.loading(enrollmentId, {
        title: '建立排程',
        message: '建立中...',
      });
      return { notifId: enrollmentId };
    },
    onSuccess: (_, { ticketId }, context) => {
      queryClient.invalidateQueries({
        queryKey: [ETC_TICKET_QUERY_NAMESPACE, 'list'],
      });
      queryClient.invalidateQueries({
        queryKey: [ETC_TICKET_QUERY_NAMESPACE, 'item', ticketId],
      });
      if (!context?.notifId) return;
      mutationNotif.toSuccess(context?.notifId, '排程已建立');
    },
    onError: (_, __, context) => {
      if (!context?.notifId) return;
      mutationNotif.toError(context.notifId, '失敗請稍後再試');
    },
  });
}

export function useDeleteScheduledEnrollment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      enrollmentId,
      scheduleId,
    }: {
      enrollmentId: string;
      scheduleId: string;
      ticketId: string;
    }) => deleteScheduledEnrollments({ enrollmentId, scheduleId }),
    onMutate: ({ enrollmentId }) => {
      mutationNotif.loading(enrollmentId, {
        title: '取消排程',
        message: '取消中...',
      });
      return { notifId: enrollmentId };
    },
    onSuccess: (_, { ticketId }, context) => {
      queryClient.invalidateQueries({
        queryKey: [ETC_TICKET_QUERY_NAMESPACE, 'list'],
      });
      queryClient.invalidateQueries({
        queryKey: [ETC_TICKET_QUERY_NAMESPACE, 'item', ticketId],
      });
      if (!context?.notifId) return;
      mutationNotif.toSuccess(context.notifId, '排程已取消');
    },
    onError: (_, __, context) => {
      if (!context?.notifId) return;
      mutationNotif.toError(context.notifId, '失敗請稍後再試');
    },
  });
}
